import { Capacitor } from '@capacitor/core'
import { Camera } from '@capacitor/camera'

export async function ensureCameraPermission(): Promise<boolean> {
  if (!Capacitor.isNativePlatform()) return true
  const current = await Camera.checkPermissions()
  if (current.camera === 'granted') return true
  const req = await Camera.requestPermissions({ permissions: ['camera'] })
  return req.camera === 'granted'
}

/** Gallery / file-picker uploads on Android 13+ */
export async function ensurePhotosPermission(): Promise<boolean> {
  if (!Capacitor.isNativePlatform()) return true
  const current = await Camera.checkPermissions()
  if (current.photos === 'granted' || current.photos === 'limited') return true
  const req = await Camera.requestPermissions({ permissions: ['photos'] })
  return req.photos === 'granted' || req.photos === 'limited'
}
